import { PlaylistDTO as PlaylistDTOV3 } from "../v3/playlist/PlaylistDTO";
import { PlaylistLocalStoragePersistence as PlaylistLocalStoragePersistenceV3 } from "../../localStoragePersistence/v3/playlist/PlaylistLocalStoragePersistence";
import {
  PlaylistDTO as PlaylistDTOV4,
  PlaylistDTOCompanion,
} from "../v4/playlist/PlaylistDTO";
import { PlaylistItemDTO as PlaylistItemDTOV3 } from "../v3/playlist/PlaylistItemDTO";
import { PlaylistLocalStoragePersistence as PlaylistLocalStoragePersistenceV4 } from "../../localStoragePersistence/v4/playlist/PlaylistLocalStoragePersistence";
import { PlaylistItemDTO } from "../v4/playlist/PlaylistItemDTO";
import { DtoId } from "../DtoId";

export class PlaylistV3ToV4 {
  public static migrate() {
    console.info("Performing migration: PlaylistV3ToV4");
    const playlistLocalStoragePersistence =
      new PlaylistLocalStoragePersistenceV3();
    playlistLocalStoragePersistence
      .loadAllIdentifiersWithSchemaV3()
      .map((i) => this.migratePlaylist(i));
  }

  private static migratePlaylist(identifier: DtoId) {
    const convertedPlaylist = this.readV3PlaylistAndConvert(identifier);
    console.info(
      "Persisting migrated playlist identifier=" + identifier,
      convertedPlaylist,
    );
    if (convertedPlaylist)
      new PlaylistLocalStoragePersistenceV4().persist(convertedPlaylist);
  }

  private static readV3PlaylistAndConvert(identifier: DtoId) {
    const playlistLocalStoragePersistence =
      new PlaylistLocalStoragePersistenceV3();
    const v3 = playlistLocalStoragePersistence
      .load(identifier)
      .orTee((e) =>
        console.error("Could not read v3 playlist. Ignoring for migration.", e),
      )
      .unwrapOr(undefined);
    return v3 !== undefined ? this.v3ToV4(v3) : undefined;
  }

  private static v3ToV4(v3Playlist: PlaylistDTOV3): PlaylistDTOV4 {
    const itemsv4: readonly PlaylistItemDTO[] = v3Playlist.items.map(
      (v3: PlaylistItemDTOV3) => {
        const songId =
          v3.tocId &&
          v3.tocId.sourceSystem !== undefined &&
          v3.tocId.songId !== undefined
            ? v3.tocId.sourceSystem + "_" + v3.tocId.songId
            : undefined;
        return { songId, title: v3.title, note: v3.note };
      },
    );
    return PlaylistDTOCompanion.create(
      v3Playlist.identifier,
      v3Playlist.title,
      v3Playlist.tags,
      v3Playlist.belongsToCrew,
      itemsv4,
      v3Playlist.createdAt,
      v3Playlist.updatedAt,
      v3Playlist.lastServerVersion,
      v3Playlist.needsPush,
      v3Playlist.isQrScannedPlaylist,
      v3Playlist.isRemoved,
    );
  }
}
